export default __webpack_public_path__ + "static/CentraNo2-Book-b8c8686691ad9d33e611770f99d0ef42.woff";